import { useMutation, useQueryClient } from "@tanstack/react-query";
import useWorkspace from "../workspaces/useWorkspace";
import { useAtomValue } from "jotai";
import { tenantIDAtom } from "../../../atoms/GlobalAtoms";
import FolderAPI from "../../api/FolderAPI";
import { newToastEvent } from "../../../utils/ToastUtil";

const useDuplicateFolder = () => {
  const { workspace } = useWorkspace();
  const queryClient = useQueryClient();
  const tenantID = useAtomValue(tenantIDAtom);

  const duplicateFolder = useMutation({
    mutationFn: (folderID: string) =>
      FolderAPI.duplicateFolder(workspace.id, folderID).then((data) => {
        return { data, workspace, folderID };
      }),
    onSuccess: ({ workspace }) => {
      queryClient.invalidateQueries({
        queryKey: ["workspaces", tenantID],
      });
      queryClient.invalidateQueries({
        queryKey: ["pages", workspace.id],
      });
      queryClient.invalidateQueries({
        queryKey: ["workspace", workspace.id],
      });
      newToastEvent("success", "Successfully duplicated folder.");
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return {
    duplicateFolder: duplicateFolder.mutate,
    folderDuplicating: duplicateFolder.isPending,
  };
};

export default useDuplicateFolder;
